module.exports = __webpack_public_path__ + "img/adModel1.ce5ba989.png";